<template>
    <section class="section">
        <div class="container is-max-widescreen is-max-desktop">
            <h1 class="title has-text-centered">
                Tableau détail des phases
            </h1>

            <b-field grouped>

                <b-field label="Filtre rapide sur les projets">
                    <b-input type="text"
                             v-model="filterP"
                             @input="searchP()">
                    </b-input>
                </b-field>
                <b-field label="Filtre rapide sur les responsables">
                    <b-input type="text"
                             v-model="filterR"
                             @input="searchR()">
                    </b-input>
                </b-field>
                <b-field label="Dossier">
                    <b-select
                        placeholder="Dossiers"
                        @input="filterByFolder">
                        <option value="all">Tout</option>
                        <option
                            v-for="dossier in folders"
                            :value="dossier"
                            :key="dossier">
                            {{ dossier }}
                        </option>
                    </b-select>
                </b-field>

                <b-field label="Arrondir">
                    <b-switch v-model="isRounded">
                        Arrondir les valeurs
                    </b-switch>
                </b-field>

            </b-field>

            <hr>

            <!-- Boites -->
            <div class="columns">

                <div class="column">
                    <div class="box">
                        <p class="subtitle">Nombre de jours</p>
                        {{ isRounded ? roundTwoDigits(filterSum().sumJ, 2) : filterSum().sumJ }} jours
                    </div>
                </div>

                <div class="column">
                    <div class="box">
                        <p class="subtitle">Frais de personnel</p>
                        {{ isRounded ? roundTwoDigits(filterSum().sumTD, 2) : filterSum().sumTD }} €
                    </div>
                </div>

                <div class="column">
                    <div class="box">
                        <p class="subtitle">Frais de mission</p>
                        {{ isRounded ? roundTwoDigits(filterSum().sumFM, 2) : filterSum().sumFM }} €
                    </div>
                </div>

                <div class="column">
                    <div class="box">
                        <p class="subtitle">Achat de matériel</p>
                        {{ isRounded ? roundTwoDigits(filterSum().sumMAT, 2) : filterSum().sumMAT }} €
                    </div>
                </div>

                <div class="column">
                    <div class="box">
                        <p class="subtitle">Sous-traitance</p>
                        {{ isRounded ? roundTwoDigits(filterSum().sumSST, 2) : filterSum().sumSST }} €
                    </div>
                </div>

                <div class="column">
                    <div class="box">
                        <p class="subtitle">Frais généraux</p>
                        {{ isRounded ? roundTwoDigits(filterSum().sumFG, 2) : filterSum().sumFG }} €
                    </div>
                </div>

                <div class="column">
                    <div class="box">
                        <p class="subtitle">Coût total</p>
                        {{ isRounded ? roundTwoDigits(filterSum().sumTOT, 2) : filterSum().sumTOT }} €
                    </div>
                </div>

            </div>
            <hr>


            <b-table
                :data="data"
                ref="table"
                paginated
                per-page="15"
                detailed
                hoverable
                striped
                bordered
                custom-detail-row
                detail-key="phase"
                show-detail-icon
            >

                <b-table-column
                    field="name"
                    label="Phases et ressources"
                    v-slot="props"
                >
                    <span>
                        <b>{{ props.row.phase }}</b>
                    </span>
                </b-table-column>

                <b-table-column
                    field="user"
                    label="Responsable"
                    centered
                    v-slot="props">
                    {{ props.row.user }}
                </b-table-column>


                <b-table-column
                    field="dc"
                    label="Coût jour"
                    centered
                >
                    -
                </b-table-column>

                <b-table-column
                    field="nbjours"
                    label="Nombre jours"
                    centered
                    v-slot="props">
                    <b>
                        {{ props.row.nbJours }}
                    </b>

                </b-table-column>

                <b-table-column
                    field="fraisdepersonnel"
                    label="Frais de personnel"
                    centered
                    v-slot="props">
                    <b>
                        {{ isRounded ? roundTwoDigits(props.row.totalPersonnel, 2) : props.row.totalPersonnel }}
                    </b>

                </b-table-column>

                <b-table-column
                    field="fraisdemission"
                    label="Frais de mission"
                    centered
                    v-slot="props">
                    <b>{{ isRounded ? roundTwoDigits(props.row.totalMission, 2) : props.row.totalMission }}
                    </b>
                </b-table-column>

                <b-table-column
                    field="achatmat"
                    label="Achat de matériel"
                    centered
                    v-slot="props">
                    <b>{{
                            isRounded ? roundTwoDigits(props.row.totalMatos, 2) : props.row.totalMatos
                        }}</b>
                </b-table-column>

                <b-table-column
                    field="sst"
                    label="Sous-traitance"
                    centered
                    v-slot="props">
                    <b>{{ isRounded ? roundTwoDigits(props.row.totalSST, 2) : props.row.totalSST }}</b>
                </b-table-column>

                <b-table-column
                    field="fraisgeneraux"
                    label="Frais généraux"
                    centered
                    v-slot="props">

                    <b>
                        {{ isRounded ? roundTwoDigits(props.row.totalFG, 2) : props.row.totalFG }}
                    </b>

                </b-table-column>

                <b-table-column
                    field="couttotal"
                    label="Coût total"
                    centered
                    v-slot="props">
                    <b>
                        {{ isRounded ? roundTwoDigits(props.row.coutTotal, 2) : props.row.coutTotal }}
                    </b>

                </b-table-column>

                <!-- SUBROWS -->

                <template slot="detail" slot-scope="props">
                    <tr v-for="item in props.row.subRow" :key="item.nom">
                        <td>
                        </td>
                        <td class="">
                            <span>
                                <b-icon
                                    icon="robot"
                                    size="small"
                                    class="is-warning"
                                    v-if="item.isSupport">
                                </b-icon> {{ item.nom }}
                            </span>
                        </td>

                        <td></td>

                        <td class="has-text-centered">
                            {{ item.dc }}
                        </td>

                        <td class="has-text-centered">
                            {{ item.days }}
                        </td>

                        <td class="has-text-centered">
                            {{ item.tot ? isRounded ? roundTwoDigits(item.tot, 2) : item.tot : null }}
                        </td>
                        <td class="has-text-centered">
                            {{ item.fm ? isRounded ? roundTwoDigits(item.fm, 2) : item.fm : null }}
                        </td>
                        <td class="has-text-centered">
                            {{ item.mat ? isRounded ? roundTwoDigits(item.mat, 2) : item.mat : null }}
                        </td>
                        <td class="has-text-centered">
                            {{ item.sst ? isRounded ? roundTwoDigits(item.sst, 2) : item.sst : null }}
                        </td>
                        <td class="has-text-centered">
                            <span>
                                {{ item.fg ? isRounded ? roundTwoDigits(item.fg, 2) : item.fg : null }}
                            </span>
                        </td>

                        <td class="has-text-centered">
                            <span>
                            {{ isRounded ? roundTwoDigits(item.total, 2) : item.total }}
                            </span>
                        </td>

                    </tr>

                </template>

            </b-table>

        </div>

        <b-modal :active.sync="isProjectModalActive"
                 has-modal-card
                 full-screen>
            <DetailProject
                :detailProject="detailProject">
            </DetailProject>
        </b-modal>

    </section>
</template>

<script>

import DetailProject from "./DetailProject";

export default {
    name: "TableFinance",
    components: {DetailProject},
    mounted() {
        this.getFolders();
        this.getSynth();
    },
    computed: {},
    methods: {
        searchP() {
            this.filterR = '';
            this.data = this.dataOrigin;
            if (this.filterP.length > 1) {
                const reg = new RegExp(`${this.filterP}`, 'i');
                this.data = this.dataOrigin.filter(i => i.phase.match(reg));
            } else {
                this.data = this.dataOrigin;
            }
        },
        filterByFolder(e) {
            if (e === 'all') {
                this.data = JSON.parse(JSON.stringify(this.dataOrigin));
            } else {
                this.data = [];
                let t = JSON.parse(JSON.stringify(this.dataOrigin));
                console.log(t)
                this.data = t.filter(d => d.dossiers !== undefined ? d.dossiers.includes(e) : null);
            }
        },
        searchR() {
            // TODO : refaire ce truc de gitan
            this.filterP = '';
            if (this.filterR.length > 4) {
                this.data = [];
                let t = this.dataOrigin;
                const reg = new RegExp(`${this.filterR}`, 'i');
                this.data = t.filter(d => d.user.match(reg));
            } else if (this.filterR.length === 0) {
                this.getSynth();
            }
        },
        getSynth() {
            const loadingComponent = this.$buefy.loading.open({
                container: null
            })
            this.$axios.get(`table-phase`)
                .then(function (response) {
                    this.data = response.data;
                    this.dataOrigin = response.data;
                    console.log(this.data)
                    loadingComponent.close()
                }.bind(this))
                .catch(error => {
                    console.log(error);
                    loadingComponent.close();
                });
        },
        getFolders() {
            this.$axios.get(`ref/folders`)
                .then(function (response) {
                    this.folders = response.data.body.dossiers
                }.bind(this))
                .catch(error => {
                    console.log(error);
                });
        },
        filterSum() {
            let s =
                {
                    sumJ: 0,
                    sumTD: 0,
                    sumFM: 0,
                    sumMAT: 0,
                    sumSST: 0,
                    sumFG: 0,
                    sumTOT: 0
                };
            this.data.forEach(d => {
                s.sumJ += d.nbJours
                s.sumTD += d.totalPersonnel
                s.sumFM += d.totalMission
                s.sumMAT += d.totalMatos
                s.sumSST += d.totalSST
                s.sumFG += d.totalFG;
                s.sumTOT += d.coutTotal;
            })
            return s;
        }
    },
    data() {
        return {
            folders: [],
            data: [],
            dataOrigin: [],
            columnsVisible: {
                intituleprojet: {title: 'Intitulé du projet', display: true},
                typeprojet: {title: 'Type Projet', display: true},
                dispositif: {title: 'Dispositif', display: true},
                fraisdepersonnel: {title: 'Frais de personnel', display: true},
                fraisdemission: {title: 'Frais de missions', display: true},
                achatdemateriel: {title: 'Achat de matériel', display: true},
                soustraitance: {title: 'Sous-traitance', display: true},
                fraisgeneraux: {title: 'Frais généraux', display: true},
                couttotal: {title: 'Coût total', display: true},
                montantfinanceurs: {title: 'Prise en charge Financeurs (€)', display: true},
                resteafinancer: {title: 'Reste à financer (€)', display: true},
                marge: {title: 'Marge (€)', display: true},
            },
            showDetailIcon: true,
            filterP: '',
            filterR: '',
            isRounded: true,
            isProjectModalActive: false,
            detailProject: [],
        }
    }
}
</script>

<style scoped>

.container {
    max-width: 100%;
    padding-left: 5%;
    padding-right: 5%;
}

.pointer {
    cursor: pointer;
}

tr.is-info {
    background: #167df0;
    color: #fff;
}

.supportcolor {
    color: #9b9b9b;
}

.katex { font-size: 2em; }


</style>
